import { render, staticRenderFns } from "./pt_log.vue?vue&type=template&id=4f0062c1&"
import script from "./pt_log.vue?vue&type=script&lang=js&"
export * from "./pt_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports